import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from './services/translate.service';

@Component({
  standalone: false,
    selector: "app-root",
    templateUrl: "./app.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./app.component.scss"],
})
export class AppComponent {
    title = "Applied Particle Technology";
    /* to initialize the translation by defalut */
    constructor(private translateService: TranslateService) {}
}
